<template>
  <button
    type="button"
    class="consultant-secondary-btn"
    :class="customClass"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <i v-if="icon" :class="icon" aria-hidden="true"></i>
    <span v-if="loading" class="consultant-secondary-btn__spinner" aria-hidden="true"></span>
    <slot>{{ label }}</slot>
  </button>
</template>

<script>
export default {
  name: 'SecondaryButton',
  props: {
    label: {
      type: String,
      default: 'Export to CSV',
    },
    icon: {
      type: String,
      default: 'bi bi-download',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
  emits: ['click'],
};
</script>

<style src="../styles/SecondaryButton.css"></style>
